/**
 * @packageDocumentation
 * Shared config (constants, env shape). No secrets; env vars documented in docs/ARCHITECTURE.md.
 */
/** App name used in titles and meta. */
export const APP_NAME = "Tippo";
/**
 * Google Calendar booking link behind every "Book a demo" CTA.
 *
 * Single source of truth — the same URL was previously copy-pasted into
 * /contact, /employers and /faq, so changing the booking link meant finding
 * three literals and hoping none were missed (FW-359).
 */
export const BOOK_A_DEMO_URL = "https://calendar.app.google/9omKKFqMF62iCwuV7";
